// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footerInfo":"uyF24c","address":"_1SXs1j","infoLinksWrapper":"_3nDta4","infoTextWrapper":"_2TP3SV","infoText":"_1Lsuw3","internalLink":"_2-jlSh"};